import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_ENDPOINTS } from "../../API/EndPoints";
import AxiosInstance from "../../API/AxiosInstance";

export const fetchTodayPatients = createAsyncThunk(
  "report/fetchTodayPatients",
  async (doctorId, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.get(
        `${API_ENDPOINTS.GET_TODAY_PATIENTS}?doctorId=${doctorId}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something went wrong"
      );
    }
  }
);

export const fetchStatusCounts = createAsyncThunk(
  "report/fetchStatusCounts",
  async (doctorId, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.get(
        `${API_ENDPOINTS.STATUS_COUNTS}?doctorId=${doctorId}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something went wrong"
      );
    }
  }
);

export const fetchPatientDetails = createAsyncThunk(
  "report/fetchPatientDetails",
  async (patientId, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.get(
        `${API_ENDPOINTS.PATIENT_DETAILS}?patientId=${patientId}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something went wrong"
      );
    }
  }
);

// ------------------ INITIAL STATE ------------------
const initialState = {
  todayPatients: {
    loading: false,
    error: null,
    data: null,
  },
  statusCounts: {
    loading: false,
    error: null,
    data: null,
  },
  patientDetails: {
    loading: false,
    error: null,
    data: null,
  },
};

// ------------------ SLICE ------------------
const PatientSlice = createSlice({
  name: "Patient",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTodayPatients.pending, (state) => {
        state.todayPatients.loading = true;
        state.todayPatients.error = null;
      })
      .addCase(fetchTodayPatients.fulfilled, (state, action) => {
        state.todayPatients.loading = false;
        state.todayPatients.data = action.payload;
      })
      .addCase(fetchTodayPatients.rejected, (state, action) => {
        state.todayPatients.loading = false;
        state.todayPatients.error = action.payload;
      });
    builder
      .addCase(fetchStatusCounts.pending, (state) => {
        state.statusCounts.loading = true;
        state.statusCounts.error = null;
      })
      .addCase(fetchStatusCounts.fulfilled, (state, action) => {
        state.statusCounts.loading = false;
        state.statusCounts.data = action.payload;
      })
      .addCase(fetchStatusCounts.rejected, (state, action) => {
        state.statusCounts.loading = false;
        state.statusCounts.error = action.payload;
      });
    builder
      .addCase(fetchPatientDetails.pending, (state) => {
        state.patientDetails.loading = true;
        state.patientDetails.error = null;
      })
      .addCase(fetchPatientDetails.fulfilled, (state, action) => {
        state.patientDetails.loading = false;
        state.patientDetails.data = action.payload;
      })
      .addCase(fetchPatientDetails.rejected, (state, action) => {
        state.patientDetails.loading = false;
        state.patientDetails.error = action.payload;
      });
  },
});

export default PatientSlice.reducer;
